import React, {Component, Fragment} from 'react';
import {withNamespaces} from "react-i18next";
import {withRouter} from "react-router-dom";
import {Basemap, Fullscreen, Locate, Polygon, PictureMarker, PointMarker} from "../../../../libs/arcgis";
import {Card, CardBody, Col, Row} from "reactstrap";
import ProblemForm from "./ProblemForm";
import SCarousel from "../../../../shared/SCarousel/SCarousel";
import {convertHex2Array} from "../../../../utils";
import queryString from "query-string";
import TreeDetails from "./TreeDetails";

class CityObjectDetails extends Component {

    constructor(props) {
        super(props);

        if(props.cityObject.images){
            let defaultImageIndex = props.cityObject.images.findIndex(image => image.default);
            this.defaultIndex = (defaultImageIndex > -1) ? defaultImageIndex : 0;
        }
    }

    render() {
        const {t, cityObject} = this.props;
        let objectType = cityObject.type && cityObject.type.title;
        if(objectType === 'Puud'){
            return (
                <TreeDetails cityObject={cityObject}/>
            )
        }

        let parsed = queryString.parse(this.props.location.search),
            fromTender = Boolean(parsed.fromTender !== undefined);

        let color = cityObject.type.color;

        return (
            <Fragment>
                <Card>
                    <CardBody>
                        <Row>
                            <Col sm={6} xs={12}>
                                <table className="table">
                                    <tbody>
                                    <tr>
                                        <td>{t('fields.objectType')}:</td>
                                        <td><b>{cityObject.type && cityObject.type.title}</b></td>
                                    </tr>
                                    <tr>
                                        <td>{t('fields.objectName')}:</td>
                                        <td><b>{cityObject.name}</b></td>
                                    </tr>
                                    <tr>
                                        <td>{t('fields.buildingYear')}:</td>
                                        <td><b>{cityObject.buildingYear}</b></td>
                                    </tr>
                                    <tr>
                                        <td>{t('fields.actual')+" "+t("fields.areaM")}:</td>
                                        <td><b>{cityObject.area}</b></td>
                                    </tr>
                                    <tr>
                                        <td>{t('fields.cityPart')}:</td>
                                        <td><b>{cityObject.cityPart && cityObject.cityPart.name}</b></td>
                                    </tr>
                                    <tr>
                                        <td>{t('fields.addressNotADS')}:</td>
                                        <td><b>{cityObject.address}</b></td>
                                    </tr>
                                    {cityObject.playgroundAges && cityObject.playgroundAges.length > 0 &&
                                    <tr>
                                        <td>{t('fields.ageGroups')}:</td>
                                        <td>
                                            <ul>
                                                {cityObject.playgroundAges.map((age, index) =>
                                                    (<li key={index}>{t('ages.' + (age.value ? age.value : age))}</li>))
                                                }
                                            </ul>
                                        </td>
                                    </tr>
                                    }
                                    {cityObject.elements && cityObject.elements.length > 0 &&
                                    <tr>
                                        <td>{t('sidebar.objectsElements')}:</td>
                                        <td>
                                            <ul>{cityObject.elements.map((element, index) => (
                                                <li key={index}>{element.name}</li>))}</ul>
                                        </td>
                                    </tr>
                                    }
                                    </tbody>
                                </table>
                            </Col>
                            <Col sm={6} xs={12}>
                                {cityObject.images && (
                                    <SCarousel
                                        items={cityObject.images}
                                        defaultIndex={this.defaultIndex}
                                        alt={cityObject.name}
                                        lightbox
                                    />
                                )}
                            </Col>
                        </Row>

                        {!fromTender &&
                        <ProblemForm cityObject={cityObject}/>
                        }

                    </CardBody>
                </Card>

                {cityObject.geom &&
                <Card className='card-default p-0'>
                    <Basemap
                        rememberLayerListState={false}
                        goToOnLoad={cityObject.geom}
                    >
                        <Fullscreen/>
                        <Locate/>
                        {cityObject.geom.polygon &&
                        <Polygon
                            key={cityObject.id}
                            geometry={cityObject.geom.polygon}
                            object={cityObject}
                            wkid={cityObject.geom.srid}
                            color={convertHex2Array(color, 0.7)}
                            outlineColor='white'
                            outlineWidth={0.5}
                        />
                        }
                        {cityObject.geom.point &&
                        (cityObject.type.icon
                            ? <PictureMarker
                                    key={cityObject.id}
                                    x={parseFloat(cityObject.geom.point.x)}
                                    y={parseFloat(cityObject.geom.point.y)}
                                    url={process.env.REACT_APP_API_V2 + "object_type/" + cityObject.type.id + "/icon.svg"
                                        + "?rand=" + new Date().getTime()
                                    }
                                />
                            : <PointMarker
                                    key={cityObject.id}
                                    x={parseFloat(cityObject.geom.point.x)}
                                    y={parseFloat(cityObject.geom.point.y)}
                                    color={convertHex2Array(cityObject.type.color, 0.7)}
                                />
                        )}
                    </Basemap>
                </Card>
                }
            </Fragment>
        );
    }
}

export default withRouter(withNamespaces('common')(CityObjectDetails));
